import React, {Component} from "react";
import {Button, Col, ControlLabel, Form, FormControl, FormGroup, Row, Table} from "react-bootstrap";
import {isEqual} from "../util/equality";

function ForecastTable(props) {
    let table = <h5>Fill out estimated rainfall values then click calculate.</h5>;
    if (props.forecastData) {
        table = (<Table striped bordered condensed hover>
            <thead>
            <tr>
                <th>Forecast Period</th>
                <th>Water Availability (MCM)</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>one month ahead</td>
                <td>{props.forecastData.oneMonth}</td>
            </tr>
            <tr>
                <td>3 months ahead</td>
                <td>{props.forecastData.threeMonths}</td>
            </tr>
            <tr>
                <td>6 months ahead</td>
                <td>{props.forecastData.sixMonths}</td>
            </tr>
            </tbody>
        </Table>);
    }
    
    return table;
}

export default class WaterAvailabilityAnalysis extends Component {
    constructor(props) {
        super(props);
        this.getValues = this.getValues.bind(this);
        this.internalClick = this.internalClick.bind(this);
    }

    internalClick(e) {
        this.props.click(this.getValues());
    }

    getValues() {
        return {
            oneMonth: this.state.oneMonth,
            threeMonths: this.state.threeMonths,
            sixMonths: this.state.sixMonths,
        };
    }

    shouldComponentUpdate(newProps, newState) {
        return !isEqual(newProps, this.props) || !isEqual(newState, this.state);
    }

    render() {
        let labelWidth = 4;
        let inputWidth = 8;
        return (
            <div>
                <h4>Water Availability Analysis</h4>
                <Row>
                    <Col md={6}>
                        <Form horizontal>
                            <FormGroup controlId="oneMonth">
                                <Col componentClass={ControlLabel} sm={labelWidth}>
                                    1 month ahead (mm)
                                </Col>
                                <Col sm={inputWidth}>
                                    <FormControl type="numeric" placeholder="0"
                                                 onChange={evt => this.setState({oneMonth: evt.target.value})}/>
                                </Col>
                            </FormGroup>

                            <FormGroup controlId="threeMonths">
                                <Col componentClass={ControlLabel} sm={labelWidth}>
                                    3 months ahead (mm)
                                </Col>
                                <Col sm={inputWidth}>
                                    <FormControl type="numeric" placeholder="0"
                                                 onChange={evt => this.setState({threeMonths: evt.target.value})}/>
                                </Col>
                            </FormGroup>

                            <FormGroup controlId="sixMonths">
                                <Col componentClass={ControlLabel} sm={labelWidth}>
                                    6 months ahead (mm)
                                </Col>
                                <Col sm={inputWidth}>
                                    <FormControl type="numeric" placeholder="0"
                                                 onChange={evt => this.setState({sixMonths: evt.target.value})}/>
                                </Col>
                            </FormGroup>

                            <FormGroup>
                                <Col smOffset={labelWidth} sm={inputWidth}>
                                    <Button onClick={this.internalClick} disabled={this.props.isLoading}>
                                        {this.props.isLoading ? 'Loading...' : 'Calculate'}
                                    </Button>
                                </Col>
                            </FormGroup>
                        </Form>
                    </Col>
                    <Col md={6}>
                        <ForecastTable forecastData={this.props.forecastData}/>
                    </Col>
                </Row>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/WaterAvailabilityAnalysis.jsx